class ProductTopBar extends HTMLElement {
  constructor() {
    super();
    this.variantId = null;
  }

  connectedCallback() {
    this.cacheElements();
    this.bindEvents();
    this.syncWithMainForm();
  }

  // ---------- cache ----------
  cacheElements() {
    this.menuBtns = this.querySelectorAll('.top-bar__menu button');
    this.minusBtn = this.querySelector('.qty-minus');
    this.plusBtn  = this.querySelector('.qty-plus');
    this.input    = this.querySelector('.qty-input');
    this.addBtn   = this.querySelector('.top-bar__add');

    // main product form + inputs
    this.mainForm    = document.querySelector('form[action="/cart/add"]');
    this.mainQty     = this.mainForm?.querySelector('input[name="quantity"]');
    this.mainSelector= this.mainForm?.querySelector('[name="id"]');
  }

  // ---------- events ----------
  bindEvents() {
    // Section navigation (robust)
    this.menuBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const selector = this.#normalizeSelector(btn.dataset.target);
        if (!selector) return;

        const candidates = document.querySelectorAll(selector);
        if (!candidates.length) {
          console.warn('ProductTopBar: target not found for', selector);
          return;
        }

        // Prefer a target inside common product containers; else first match
        let target = candidates[0];
        for (const el of candidates) {
          if (el.closest('.product-information, .product-details, [data-product-page], .shopify-section')) {
            target = el;
            // target = { ...target, offsetTop: (target.offsetTop - 80) };
            break;
          }
        }

        const top = this.#pageY(target) - this.#getStickyOffset();
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });

    // Quantity controls
    if (this.minusBtn) {
      this.minusBtn.addEventListener('click', () => {
        const val = Math.max(1, parseInt(this.input.value || '1', 10) - 1);
        this.input.value = val;
        if (this.mainQty) this.mainQty.value = val;
      });
    }

    if (this.plusBtn) {
      this.plusBtn.addEventListener('click', () => {
        const val = (parseInt(this.input.value || '1', 10) + 1);
        this.input.value = val;
        if (this.mainQty) this.mainQty.value = val;
      });
    }

    if (this.input) {
      this.input.addEventListener('change', () => {
        let val = parseInt(this.input.value, 10);
        if (!val || val < 1) val = 1;
        this.input.value = val;
        if (this.mainQty) this.mainQty.value = val;
      });
    }

    // Delegate to main add-to-cart (keeps Horizon’s AJAX, drawer & fly-to-cart)
    if (this.addBtn) {
      this.addBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (!this.mainForm) return;

        if (this.mainQty && this.input) this.mainQty.value = this.input.value;

        const mainAddBtn = this.mainForm.querySelector('[type="submit"], button[name="add"]');
        if (mainAddBtn) {
          mainAddBtn.click();
        } else {
          console.warn('ProductTopBar: main Add to Cart button not found.');
        }
      });
    }
  }

  // ---------- sync w/ main form ----------
  syncWithMainForm() {
    if (!this.mainSelector) return;

    this.variantId = this.mainSelector.value;
    if (this.mainQty && this.input) this.input.value = this.mainQty.value;

    this.mainSelector.addEventListener('change', (e) => {
      this.variantId = e.target.value;
    });

    this.mainQty?.addEventListener('change', (e) => {
      if (this.input) this.input.value = e.target.value;
    });
  }

  // ---------- helpers ----------
  #normalizeSelector(sel) {
    if (!sel) return null;
    const s = sel.trim();
    if (!s) return null;
    // Accept "#id", ".class", or "class" (we convert to ".class")
    if (s.startsWith('#') || s.startsWith('.')) return s;
    return '.' + s;
  }

  #pageY(el) {
    // absolute document Y for element top
    const rect = el.getBoundingClientRect();
    return rect.top + window.scrollY;
  }

  #getStickyOffset() {
    // Allow manual override via attribute: <product-top-bar offset="96">
    const manual = parseInt(this.getAttribute('offset') || '', 10);
    if (!Number.isNaN(manual)) return manual;

    let offset = 0;

    // Header (Horizon usually has a sticky header section)
    const header =
      document.querySelector('.shopify-section-header') ||
      document.querySelector('header.header, header[role="banner"], .header--sticky');

    if (header) offset += header.getBoundingClientRect().height;

    // This top bar itself (if sticky/fixed)
    const bar =
      this.querySelector('.top-bar__inner') ||
      this;

    if (bar) {
      const pos = getComputedStyle(bar).position;
      if (pos === 'sticky' || pos === 'fixed') {
        offset += bar.getBoundingClientRect().height;
      }
    }

    // Small buffer so the title isn’t flush to the edge
    return Math.max(0, Math.round(offset)) + 8;
  }
}

if (!customElements.get('product-top-bar')) {
  customElements.define('product-top-bar', ProductTopBar);
}
